import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Jacket } from '../Jacket/Jacket.js';
import { useThemeContext } from '../../contexts/session/Theme.js';
import { mapBorderStyles } from './Card.mappers.js';
import { CardStyled } from './Card.styled.js';
import cardInteractiveState from './cardInteractiveState.js';

var _excluded = ["type", "variant", "status", "children", "backgroundColor", "jacket", "borderRadius"];
var nonInteractiveBackground = {
  'elevation-s': 'base.surface',
  'elevation-m': 'base.surface',
  'elevation-l': 'base.surface',
  outlined: 'base.surface',
  filled: 'base.background'
};
var nonInteractiveShadow = {
  'elevation-s': 'bottom-s',
  'elevation-m': 'bottom-m',
  'elevation-l': 'bottom-l',
  outlined: undefined,
  filled: undefined
};
var interactiveBackground = {
  default: 'base.surface',
  selected: 'base.surface',
  viewed: 'product.primary.subtle',
  error: 'base.surface'
};

/**
 * Card is a container used to hold or group similar information together. It can either be interactive or not interactive.
 */
var Card = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var type = props.type,
    variant = props.variant,
    status = props.status,
    children = props.children,
    backgroundColor = props.backgroundColor,
    jacket = props.jacket,
    borderRadius = props.borderRadius,
    rest = _objectWithoutProperties(props, _excluded);
  var theme = useThemeContext();
  var isInteractive = type === 'interactive';
  var defaultVariant = variant || 'elevation-s';
  var defaultStatus = status || 'default';
  var background = !isInteractive && variant === 'filled' ? backgroundColor || nonInteractiveBackground[defaultVariant] : nonInteractiveBackground[defaultVariant];
  var interactiveState = isInteractive ? cardInteractiveState(theme) : undefined;
  var jacketElement = jacket && /*#__PURE__*/React.createElement(Jacket, _extends({}, jacket, {
    borderRadius: "0"
  }));
  var withJacketProps = jacket && {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    overflow: 'hidden'
  };
  return /*#__PURE__*/React.createElement(CardStyled, _extends({}, rest, withJacketProps, {
    borderRadius: jacket ? '16' : borderRadius,
    cursor: isInteractive ? 'pointer' : undefined,
    $interactiveState: interactiveState,
    backgroundColor: !isInteractive ? background : interactiveBackground[defaultStatus]
  }, mapBorderStyles(isInteractive, defaultStatus, defaultVariant), {
    boxShadow: !isInteractive ? nonInteractiveShadow[defaultVariant] : undefined,
    ref: ref
  }), (jacket === null || jacket === void 0 ? void 0 : jacket.position) === 'above' && jacketElement, children, (jacket === null || jacket === void 0 ? void 0 : jacket.position) === 'below' && jacketElement);
});
Card.defaultProps = {
  type: 'non-interactive',
  variant: 'elevation-s',
  status: 'default',
  borderRadius: '16'
};
var CardMemoized = /*#__PURE__*/React.memo(Card);
CardMemoized.displayName = 'Card';

export { CardMemoized as Card };
//# sourceMappingURL=Card.js.map
